import { DataFetchWrapper, Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { useProductQuery } from "~/pages/Brand/Products/Details/hooks.ts"

export const ProductDetailsWrapper = () => {
  const params = useParams()
  const productId = Number(params.productId)

  const productQuery = useProductQuery(productId)

  const { t } = useTranslation("products")

  const pages = useMemo<PageLink[]>(() => {
    const tabs = [
      {
        label: t("details.tabs.general"),
        link: "general",
      },
    ]

    return tabs
  }, [t])

  return (
    <DataFetchWrapper query={productQuery}>
      {({ data }) => (
        <Page title={data.name} pages={pages} data={data} canGoBack />
      )}
    </DataFetchWrapper>
  )
}
